import { render, staticRenderFns } from "./TasksFixedStatusColor.vue?vue&type=template&id=b6805ea4&scoped=true&functional=true&"
import script from "./TasksFixedStatusColor.vue?vue&type=script&lang=js&"
export * from "./TasksFixedStatusColor.vue?vue&type=script&lang=js&"
import style0 from "./TasksFixedStatusColor.vue?vue&type=style&index=0&id=b6805ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b6805ea4",
  null
  
)

export default component.exports